import { Instance, types } from 'mobx-state-tree';

export type GoogleAccountInstance = Instance<typeof GoogleAccount>;

export const GoogleAccount = types
  .model({
    isUserLogged: types.optional(types.boolean, false),
    accessToken: types.optional(types.string, ''),
    email: types.optional(types.string, ''),
    profilePic: types.optional(types.string, ''),
    hasGivenAccessToPhoto: types.optional(types.boolean, true),
  })
  .actions(self => {
    return {
      setIsUserLogged: (value: boolean) => {
        self.isUserLogged = value;
      },
      setAccessToken: (accessToken: string) => {
        self.accessToken = accessToken;
      },
      setEmail: (email: string) => {
        self.email = email;
      },
      setProfilePic: (profilePic: string) => {
        self.profilePic = profilePic;
      },
      setHasGivenAccessToPhoto: (value: boolean) => {
        self.hasGivenAccessToPhoto = value;
      },
    };
  });
